<template>
    <div v-if="showDialog" class="modal flex-container" ><!-- @click.self="$emit('close')" -->
        <div class="modal-content vertical" :style="style">
            <div class="modal-header">
                <p v-if="title != undefined" class="title"> {{title != null ? title : ''}} </p>
                <div id="mdiv" @click="$emit('close')">
                    <div class="mdiv">
                        <div class="md"></div>
                    </div>
                </div>
            </div>
            <div class="modal-slot">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        showDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        maxWidth: {
            type: String,
            required: false,
            default: ''
        },
        title: {
            type: String,
            required: false,
            default: ''
        }
    },
    watch: {
        showDialog: function(newVal, oldVal) {
        },
    },
    computed: {
        style () {
            return 'max-width: ' + this.maxWidth;
        }
    },
}
</script>

<style scoped>
.modal {
    position: fixed;
    z-index: 10;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    display: block;
    background-color: rgba(0,0,0,0.4);
}

.flex-container {
    height: 100%;
    padding: 0;
    margin: 0;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal-content {
    background-color: #fefefe;
    border: unset;
    width: auto;
    z-index: 1000;
    border-radius: 5px;
    box-shadow: 0px 4px 10px rgba(0,0,0,0.2);
}

.modal-header {
    background-color:  #34758E;
    width: 100%;
    font-family: "SourceSansProBold", sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    color: white;
}

.close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
}

.widthClass {
    max-width: 30%;
}

.modal-slot {
    /* margin-right: 10px;
    margin-left: 10px; */
}

#mdiv {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.mdiv {
  height: 25px;
  width: 2px;
  margin-left: 12px;
  background-color: white;
  transform: rotate(45deg);
  Z-index: 1;
}

.md {
  height: 25px;
  width: 2px;
  background-color: white;
  transform: rotate(90deg);
  Z-index: 2;
}

</style>



// WEBPACK FOOTER //
// src/components/Modal.vue